import React, { useState } from 'react';

export const DataSection: React.FC = () => {
  const stats = [
    {
      number: "50",
      label: "notícias de grandes veículos analisadas",
      icon: "ri-newspaper-line"
    },
  ];

  return (
    <section id="dados" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4 font-serif">
            Dados da Investigação
          </h2>
        </div>

        {/* Statistics Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-16">
          <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200 text-center">
            <div className="text-3xl font-bold text-red-600 mb-2">50</div>
            <p className="text-gray-700 font-medium text-sm">notícias de grandes veículos analisadas</p>
          </div>
          
          <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200 text-center">
            <div className="text-3xl font-bold text-blue-600 mb-2">26,1%</div>
            <p className="text-gray-700 font-medium text-sm">apresentavam diversidade nas fontes e contraposições à narrativa dos órgãos de segurança pública</p>
          </div>
          
          <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200 text-center">
            <div className="text-3xl font-bold text-green-600 mb-2">73,91%</div>
            <p className="text-gray-700 font-medium text-sm">delas não possuía nenhuma fonte além das oficiais</p>
          </div>
          
          <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200 text-center">
            <div className="text-3xl font-bold text-purple-600 mb-2">4,34%</div>
            <p className="text-gray-700 font-medium text-sm">dos textos com mais de uma fonte tiveram a participação de Defensorias e Ministérios Públicos</p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200 text-center">
            <div className="text-3xl font-bold text-orange-600 mb-2">93,48%
</div>
            <p className="text-gray-700 font-medium text-sm">das matérias tinham as fontes oficiais como principais no texto</p>
          </div>
        </div>

        {/* Data Sources */}
        <div className="bg-blue-50 rounded-lg p-6 border border-blue-200">
          <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
            <i className="ri-information-line text-blue-600 mr-2"></i>
            Fontes do Levantamento
          </h4>
          <p className="text-gray-700 text-sm leading-relaxed">
            Os dados apresentados foram coletados de matérias dos jornais Folha de São Paulo, O Globo, Estadão, G1 e Uol, referentes ao período de 2020 a 2025.
          </p>
        </div>
      </div>
    </section>
  );
};
